import WebComponent from '../base/WebComponent';
import { FormStateEnum } from "./../../models/formCustomRoute.models";

export default class StepBase extends WebComponent {
    isMobile = window.matchMedia("(max-width: 768px)").matches;
    props = {
        handler: null,
        index: null,
        data: null,
        navhandler: null,
        route: null,
        active: null
    };

    handleForm({ input, submit = false, dir = 1 }) {
        if (this.props.handler && this.props.navhandler) {
            this.props.handler({ input, submit }).then(() => {
                if (!submit) this.props.navhandler(this.props.index + dir);
            });
        }
    }

    routeSuccess() {
        return this.props.route.state ? this.props.route.state === FormStateEnum.success : false;
    }
}